<template>
  <div class="user-list">
    <div class="search-bar flex">
      <div class="left">
        <el-input v-model="searchParam.keyword_search" placeholder="请输入关键词搜索"></el-input>
        <el-select v-model="searchParam.school_uuid" placeholder="校区筛选">
          <el-option v-for="item in schoolList" :key="item.uuid" :label="item.title" :value="item.uuid"></el-option>
        </el-select>

        <el-button type="primary" @click="getList">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
        <el-button @click="exportData">导出</el-button>
      </div>
      <div class="right">
        <el-button type="primary" @click="addStudent">新增老师</el-button>
      </div>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="teacher_no" label="老师编号"> </el-table-column>
        <el-table-column prop="name" label="老师姓名"> </el-table-column>
        <el-table-column prop="school_uuid" label="所属校区">
          <template slot-scope="scope">
            {{ getSchoolName(scope.row.school_uuid) }}
          </template>
        </el-table-column>
        <el-table-column prop="teach_count" label="授课数量"> </el-table-column>
        <el-table-column prop="create_time" label="添加日期"> </el-table-column>
        <el-table-column width="250" label="操作">
          <template slot-scope="scope">
            <!-- <el-button class="mid-blue" @click="toDetail(scope.row)">推荐</el-button> -->
            <el-button class="mid-blue" @click="toSchedule(scope.row)">日程</el-button>
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getTeacherList, deleteTeacher, exportTeacher } from "@/api/teacher.js";

import { mixin } from "@/mixins/pagination.js";
import { mschool } from "../mixins.js";
export default {
  components: {},
  mixins: [mixin, mschool],
  data() {
    return {
      loading: false,
      total: 0,
      searchParam: {
        keyword_search: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    this.getSchool();
  },
  methods: {
    getSchoolName(uuid) {
      const it = this.schoolList.find((item) => {
        return item.uuid == uuid;
      });
      if (it) {
        return it.title;
      }
    },
    exportData() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        type: 1,
      };
      exportTeacher(param);
    },
    resetSearch() {
      this.searchParam = {};
      this.getList();
    },
    addStudent() {
      this.$router.push({ path: "/teacher-add" });
    },
    toSchedule(row) {
      this.$router.push({ path: "/teacher-schedule", query: row });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({ path: "/teacher-add", query: row });
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        type: 1,
      };
      console.log(param);
      this.loading = true;
      const res = await getTeacherList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.total = res.total;
        this.tableData = res.data;
      }
      console.log(res);
    },
    deleteItem(row) {
      console.log(row);
      this.$confirm("确定要删除该老师吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTeacher(row.uuid).then((res) => {
            console.log(res);
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
          // this.userOption()
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
